module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container"
  }, [(_vm.salesOrder && _vm.newPix == false && !_vm.hideButton) ? _c('h3', {
    staticClass: "title-info-reprocess",
    class: _vm.salesOrder.salesOrderStatus.salesOrderStatusId == 2 ? 'green' : 'red'
  }, [_vm._v(_vm._s(_vm.salesOrder.salesOrderStatus.description))]) : _vm._e(), _vm._v(" "), (_vm.salesOrder && _vm.code == null && !_vm.newPix) ? _c('generic-summary', {
    attrs: {
      "account": _vm.user,
      "order": _vm.salesOrder,
      "contract": _vm.contract,
      "showAddress": true,
      "reprocess": true,
      "skipBillingSection": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.salesOrder && _vm.salesOrder.salesOrderStatus && _vm.salesOrder.salesOrderStatus.salesOrderStatusId == 3 && _vm.newPix == false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(!_vm.hideButton) ? _c('button', {
    staticClass: "btn btn-success margin-t20 pull-right",
    on: {
      "click": _vm.getPayment
    }
  }, [_vm._v("\n        Reprocessar\n        "), _c('i', {
    staticClass: "icon-coin align-icon-right-white"
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('success-page', {
    attrs: {
      "code": _vm.code,
      "boletoUrl": null,
      "type": 'reprocess',
      "novoCartao": _vm.novoCartao,
      "newPix": _vm.newPix,
      "pixCopiaCola": _vm.pixCopiaCola,
      "salesOrder": _vm.salesOrder,
      "usuario": _vm.usuario,
      "validado": _vm.validado
    }
  }), _vm._v(" "), _c('error-page', {
    attrs: {
      "code": _vm.code,
      "stepPayment": 1,
      "type": 'reprocess',
      "salesOrder": _vm.salesOrder,
      "validacaoFraude": _vm.validacaoFraude,
      "cmpId": _vm.cpmId
    },
    on: {
      "goToStep": _vm.goToStep
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-a5f7afbc!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/reprocess-order.vue
// module id = 2198
// module chunks = 1